// extracted by mini-css-extract-plugin
export default {"badge":"DraftIndicator_badge__+L7my","loadingDot":"DraftIndicator_loadingDot__s-eUd","pulse":"DraftIndicator_pulse__l+yf9"};